import useLocaleText from 'components/useLocaleText'
import React from 'react'
import { Box } from '@chakra-ui/core'
import { Controller, useFormContext } from 'react-hook-form'
import { TaskInput } from 'components/TasksV2/UI/TaskInput'
import { Subtask } from 'components/TasksV2/TaskCreation/FormStepContext'
import { useTranslateDefaultTitle } from 'components/TasksV2/hooks/useTranslateDefaultTitle'
import { useBuilderWidget } from 'components/TasksV2/TaskCreation/contexts/BuilderWidgetContext'
import { useCreationText } from 'components/TasksV2/TaskCreation/hooks/useCreationText'

interface Props {
  questionName: string
  field: Subtask
}
export const VideoQuestion: React.FC<Props> = ({ questionName, field }) => {
  const { control } = useFormContext()
  const validationMessage = useLocaleText('t_video_st_error')
  const builder = useBuilderWidget()
  const creationText = useCreationText()
  const t_pls_add_video = useLocaleText('t_pls_add_video')
  const translatedTitle = useTranslateDefaultTitle(field?.title)

  return (
    <Box my={builder ? '0' : '15px'}>
      {builder && (
        <label className="creation-field-label" htmlFor={`${questionName}-input`}>
          {creationText.subtaskTitle} <span>*</span>
        </label>
      )}
      <Controller
        as={TaskInput}
        name={questionName}
        id={builder ? `${questionName}-input` : undefined}
        control={control}
        placeholder={t_pls_add_video}
        rules={{
          required: validationMessage,
          validate: (value) => {
            return value.trim() !== '' || validationMessage
          },
        }}
        key={questionName}
        boxShadow="none"
        borderRadius="10px"
        border="none"
        defaultValue={translatedTitle}
      />
    </Box>
  )
}
